import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-72d5f81e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "more-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "total-count"
}
const _hoisted_4 = { key: 1 }

import { getType } from '@/utils/tool'
import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'item-group',
  props: {
  data: {
    type: [Array, String] as PropType<String[] | String>,
    default: ''
  },
  /** 显示最大的条数 */
  max: {
    type: Number,
    default: 1
  },
  /** 空值时展示 */
  empty: {
    type: String,
    default: '--'
  },
  /** 分隔符 */
  separator: {
    type: String,
    default: '，'
  },
  /** 单位 */
  unit: {
    type: String,
    default: '个'
  },
  /** 自定义总数，适用于后端提供仅一部分数据时 */
  customTotal: {
    type: [Number, String]
  },
  tooltip: {
    type: Boolean,
    default: true
  },
  placement: {
    type: String,
    default: 'top'
  }
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const {t} = useI18n()
const props = __props

const emits = __emit

const groupShow = computed<String[]>(() => {
  let groupData = props.data
  if (!props.data) {
    groupData = []
  } else if (getType(props.data) !== 'array') {
    groupData = [props.data as string]
  }
  return groupData as String[]
})

const total = computed(() => props.customTotal ?? groupShow.value.length)

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (total.value)
    ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        "popper-class": "more-item-popper",
        disabled: !__props.tooltip || groupShow.value.length <= __props.max,
        effect: "light",
        placement: __props.placement
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupShow.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "more-item"
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["item-group-wrap", { clickable: !__props.tooltip && groupShow.value.length }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click', _ctx.item)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupShow.value.slice(0, __props.max), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "normal-item"
              }, [
                _createElementVNode("div", null, _toDisplayString(item), 1),
                (index !== groupShow.value.slice(0, __props.max).length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.separator), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (total.value > __props.max)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('common.total_keyword',{ count:total.value })), 1))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["disabled", "placement"]))
    : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.empty), 1))
}
}

})